import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import { Modal } from 'antd';
import { images } from '../../config/image';
import PublicFooter from '../../components/Layout/PublicFooter';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';
const { confirm } = Modal;

class AboutMenuScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProgressBar: true,
            lang: strings.getLanguage(),
            selectedLang: strings.getLanguage(),
            access_token: null,
            isAuthenticated: false,
            IsLanguageChange: false,
        }
    }

    async componentDidMount() {
        const user_token = await localStorage.getItem('user_token');
        this.setState({ access_token: user_token });
        this.setState({ ProgressBar: false });
    }

    async changeLanguage() {
        let obj = this.state.selectedLang;
        if (obj) {
            strings.setLanguage(obj);
            await localStorage.setItem("language", obj);
            this.setState({ selectedLang: obj });
            window.location.reload();
        }
    }

    Logout() {

    }

    showConfirm() {
        const self = this;
        confirm({
            title: strings["Are you sure you wnat to logout?"],
            content: '',
            width: 320,
            onOk() {
                localStorage.clear();
                setTimeout(() => {
                    self.setState({ isAuthenticated: true });
                }, 100);
            },
            onCancel() {
            },
        });
    };

    render() {
        if (this.state.isAuthenticated) {
            return <Navigate to="/" />;
        }
        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <Header data={{ title: strings["About Menu"] }} />

                <div className='aboutMenuScreen'>
                    <main className="menu-container">
                        <Link to={"/products"} className="menu-item">
                            <img src={images['box-icon']} alt="" />
                            <span id="productsText">{strings["productsText"]}</span>
                        </Link>
                        <Link to={"/about-us"} className="menu-item">
                            <img src={images['aboutus-icon']} alt="" />
                            <span id="aboutusText">{strings["aboutusText"]}</span>
                        </Link>
                        <Link to={"/faq"} className="menu-item">
                            <img src={images['faq-icon']} alt="" />
                            <span id="faqText">{strings["faqText"]}</span>
                        </Link>
                        <button id="languageButton" className="menu-item" onClick={() => this.setState({ IsLanguageChange: true, selectedLang: this.state.lang })}>
                            <img src={images['globe-icon']} alt="" />
                            <span id="languageText">{strings["languageText"]}</span>
                        </button>
                        <Link to={"https://www.facebook.com/aklightingkch/"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="menu-item"
                        >
                            <img src={images['facebook-icon']} alt="" />
                            <span id="facebookText">{strings["facebookText"]}</span>
                        </Link>
                        {this.state.access_token ?
                            <Link onClick={() => this.showConfirm()} className="menu-item">
                                <img src={images['logout-icon']} alt="" />
                                <span id="logoutText">{strings["logoutText"]}</span>
                            </Link>
                            :
                            <Link to={"/login"} className="menu-item">
                                <img src={images['login-icon']} alt="" />
                                <span id="logoutText">{strings["loginButton"]}</span>
                            </Link>
                        }
                    </main>
                </div>

                {this.state.access_token ?
                    <Footer />
                    :
                    <PublicFooter />
                }

                <Modal
                    title={strings["languageText"]}
                    open={this.state.IsLanguageChange}
                    onOk={() => this.changeLanguage()}
                    onCancel={() => this.setState({ IsLanguageChange: false })}
                    width={320}
                    className='languageModal'
                >
                    <div className="popup-wrap">
                        <div className="language-options">
                            <button onClick={() => this.setState({ "selectedLang": "EN" })} className="language-btn" data-lang="en">
                                English
                                {this.state.selectedLang == 'EN' ?
                                    <img
                                        src={images["tick-icon"]}
                                        className="tick-icon"
                                        alt="tick"
                                    />
                                    : null}
                            </button>
                            <button onClick={() => this.setState({ "selectedLang": "CHN" })} className="language-btn" data-lang="chn">
                                中文
                                {this.state.selectedLang == 'CHN' ?
                                    <img
                                        src={images["tick-icon"]}
                                        className="tick-icon"
                                        alt="tick"
                                    />
                                    : null}
                            </button>
                            <button onClick={() => this.setState({ "selectedLang": "MS" })} className="language-btn" data-lang="ms">
                                Malay
                                {this.state.selectedLang == 'MS' ?
                                    <img
                                        src={images["tick-icon"]}
                                        className="tick-icon"
                                        alt="tick"
                                    />
                                    : null}
                            </button>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

export default AboutMenuScreen;
